// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
  min-height: 0;
}

.questionnaire {
  background: #fff;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(19, 42, 70, 0.08);
  display: grid;
  grid-template-rows: auto auto minmax(0, 1fr) auto;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.questionnaire-header {
  align-items: center;
  background: #f7f9fc;
  border-bottom: 1px solid #d6e0ea;
  border-left: 4px solid #007bff;
  color: #173a5e;
  display: grid;
  gap: 0.7rem;
  grid-template-columns: auto 1fr auto auto;
  height: auto !important;
  margin: 0 !important;
  max-width: none !important;
  min-height: 54px !important;
  padding: 0.35rem 0.65rem;
  width: auto !important;
}

.questionnaire-header::before,
.questionnaire-header::after {
  content: none !important;
  display: none !important;
}

h2 {
  font-size: 1rem;
  margin: 0;
}

.progress-text {
  color: #66798b;
  font-size: 0.65rem;
}

.rating-key {
  display: flex;
  flex-wrap: wrap;
  color: #53687b;
  font-size: 0.62rem;
  gap: 0.25rem 0.75rem;
  justify-content: center;
}

.rating-key strong {
  background: #e3edf6;
  border-radius: 3px;
  color: #1f4e78;
  display: inline-block;
  margin-right: 0.15rem;
  text-align: center;
  width: 18px;
}

.score-box {
  align-items: center;
  background: #e4f2fb;
  border: 1px solid #bfdced;
  border-radius: 6px;
  display: grid;
  font-size: 0.72rem;
  grid-template-columns: auto auto;
  padding: 0.3rem 0.55rem;
}

.score-box strong {
  color: #123f67 !important;
  font-size: 1.15rem;
  font-weight: 800;
  grid-row: span 2;
  margin-left: 0.6rem;
  text-shadow: none;
}

.clean-form-button {
  background: #fff;
  border: 1px solid #9aa9b8;
  border-radius: 4px;
  color: #334b62;
  cursor: pointer;
  font-size: 0.7rem;
  font-weight: 700;
  min-height: 30px;
  min-width: 78px;
  padding: 0.3rem 0.85rem;
}

.clean-form-button:hover,
.clean-form-button:focus-visible { border-color: #b4233f; color: #9b1c35; outline: none; }

.column-headings,
.question-row {
  display: grid;
  gap: 0.5rem;
  grid-template-columns: minmax(300px, 2.8fr) 72px 108px minmax(140px, 1fr) 30px;
}

.column-headings {
  background: #d9eaf7;
  color: #18364f;
  font-size: 0.61rem;
  font-weight: 700;
  padding: 0.18rem 0.45rem;
  text-align: center;
  text-transform: uppercase;
}

.column-headings span:first-child,
.column-headings span:nth-child(4) {
  text-align: left;
}

.questions {
  align-content: start;
  display: grid;
  grid-auto-rows: minmax(29px, auto);
  min-height: 0;
  overflow-y: auto;
}

.questions.grouped {
  grid-auto-rows: minmax(29px, auto);
}

.question-group-heading {
  background: #e8f1f8;
  border-bottom: 1px solid #cad9e6;
  color: #173a5e;
  font-size: 0.72rem;
  margin: 0;
  padding: 0.25rem 0.55rem;
}

.question-row {
  align-items: center;
  border-bottom: 1px solid #e3e7ed;
  min-height: 0;
  padding: 0.08rem 0.45rem;
}

.question-row:nth-child(even) {
  background: #f8fafc;
}

.question-text {
  align-items: flex-start;
  display: flex;
  font-size: clamp(0.58rem, 0.76vw, 0.7rem);
  line-height: 1.05;
}

.question-text span {
  background: #e8eef5;
  border-radius: 50%;
  color: #1f4e78;
  flex: 0 0 17px;
  font-size: 0.58rem;
  font-weight: 700;
  line-height: 17px;
  margin-right: 0.3rem;
  text-align: center;
}

.choice-group {
  display: flex;
  gap: 0.1rem;
  justify-content: center;
}

.choice-group button {
  background: #fff;
  border: 1px solid #aab5c3;
  border-radius: 4px;
  color: #34495e;
  cursor: pointer;
  font-size: 0.61rem;
  font-weight: 700;
  min-height: 20px;
  min-width: 31px;
  padding: 0.05rem 0.4rem;
}

.choice-group button:hover,
.choice-group button:focus-visible {
  border-color: #007bff;
  outline: none;
}

.choice-group button.selected {
  background: #007bff;
  border-color: #007bff;
  color: #fff;
}

.rating-group button {
  min-width: 25px;
  padding-inline: 0.4rem;
}

.comment-input,
textarea {
  border: 1px solid #b8c2ce;
  border-radius: 4px;
  font: inherit;
  min-width: 0;
  line-height: 1.05;
  padding: 0.18rem 0.35rem;
  width: 100%;
}

.comment-input {
  font-size: 0.65rem;
  height: 24px;
  min-height: 24px;
  overflow: auto;
  resize: none;
  white-space: pre-wrap;
}

.comment-input:focus,
textarea:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.15);
  outline: none;
}

.points {
  color: #1f4e78;
  font-size: 0.65rem;
  text-align: center;
}

.questionnaire-footer {
  align-items: center;
  background: #f2f5f8;
  border-top: 1px solid #d9e2ec;
  box-sizing: border-box;
  display: grid;
  margin: 0 !important;
  max-width: none !important;
  padding: 0.5rem 0.65rem 0.6rem;
  width: 100% !important;
}

.additional-comments {
  display: grid;
  font-size: 0.72rem;
  font-weight: 700;
  gap: 0.3rem;
  grid-template-columns: minmax(0, 1fr);
  justify-self: center;
  margin: 0;
  width: 66.666%;
}

.additional-comments > span {
  color: #354a5f;
  font-size: 0.7rem;
}

textarea {
  box-sizing: border-box;
  height: 82px;
  min-height: 82px;
  resize: vertical;
}

@media (max-width: 900px) {
  .additional-comments {
    width: 100%;
  }

  .rating-key {
    display: none;
  }

  .questionnaire-header {
    grid-template-columns: 1fr auto auto;
  }

  .column-headings,
  .question-row {
    grid-template-columns: minmax(220px, 2.2fr) 68px 104px minmax(110px, 1fr) 28px;
  }
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/lab-audit-checklist/components/audit-questionnaire/audit-questionnaire.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;EAC5C,aAAa;EACb,iDAAiD;EACjD,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,8BAA8B;EAC9B,cAAc;EACd,aAAa;EACb,WAAW;EACX,yCAAyC;EACzC,uBAAuB;EACvB,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;;EAEE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;mCACmC,qBAAqB,EAAE,cAAc,EAAE,aAAa,EAAE;;AAEzF;;EAEE,aAAa;EACb,WAAW;EACX,8EAA8E;AAChF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,kCAAkC;EAClC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;EACtB,aAAa;EACb,oBAAoB;EACpB,0BAA0B;EAC1B,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,oBAAoB;EACpB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oCAAoC;EACtC;;EAEA;;IAEE,8EAA8E;EAChF;AACF","sourcesContent":[":host {\n  display: block;\n  height: 100%;\n  min-height: 0;\n}\n\n.questionnaire {\n  background: #fff;\n  border: 1px solid #d9dee7;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(19, 42, 70, 0.08);\n  display: grid;\n  grid-template-rows: auto auto minmax(0, 1fr) auto;\n  height: 100%;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.questionnaire-header {\n  align-items: center;\n  background: #f7f9fc;\n  border-bottom: 1px solid #d6e0ea;\n  border-left: 4px solid #007bff;\n  color: #173a5e;\n  display: grid;\n  gap: 0.7rem;\n  grid-template-columns: auto 1fr auto auto;\n  height: auto !important;\n  margin: 0 !important;\n  max-width: none !important;\n  min-height: 54px !important;\n  padding: 0.35rem 0.65rem;\n  width: auto !important;\n}\n\n.questionnaire-header::before,\n.questionnaire-header::after {\n  content: none !important;\n  display: none !important;\n}\n\nh2 {\n  font-size: 1rem;\n  margin: 0;\n}\n\n.progress-text {\n  color: #66798b;\n  font-size: 0.65rem;\n}\n\n.rating-key {\n  display: flex;\n  flex-wrap: wrap;\n  color: #53687b;\n  font-size: 0.62rem;\n  gap: 0.25rem 0.75rem;\n  justify-content: center;\n}\n\n.rating-key strong {\n  background: #e3edf6;\n  border-radius: 3px;\n  color: #1f4e78;\n  display: inline-block;\n  margin-right: 0.15rem;\n  text-align: center;\n  width: 18px;\n}\n\n.score-box {\n  align-items: center;\n  background: #e4f2fb;\n  border: 1px solid #bfdced;\n  border-radius: 6px;\n  display: grid;\n  font-size: 0.72rem;\n  grid-template-columns: auto auto;\n  padding: 0.3rem 0.55rem;\n}\n\n.score-box strong {\n  color: #123f67 !important;\n  font-size: 1.15rem;\n  font-weight: 800;\n  grid-row: span 2;\n  margin-left: 0.6rem;\n  text-shadow: none;\n}\n\n.clean-form-button {\n  background: #fff;\n  border: 1px solid #9aa9b8;\n  border-radius: 4px;\n  color: #334b62;\n  cursor: pointer;\n  font-size: 0.7rem;\n  font-weight: 700;\n  min-height: 30px;\n  min-width: 78px;\n  padding: 0.3rem 0.85rem;\n}\n\n.clean-form-button:hover,\n.clean-form-button:focus-visible { border-color: #b4233f; color: #9b1c35; outline: none; }\n\n.column-headings,\n.question-row {\n  display: grid;\n  gap: 0.5rem;\n  grid-template-columns: minmax(300px, 2.8fr) 72px 108px minmax(140px, 1fr) 30px;\n}\n\n.column-headings {\n  background: #d9eaf7;\n  color: #18364f;\n  font-size: 0.61rem;\n  font-weight: 700;\n  padding: 0.18rem 0.45rem;\n  text-align: center;\n  text-transform: uppercase;\n}\n\n.column-headings span:first-child,\n.column-headings span:nth-child(4) {\n  text-align: left;\n}\n\n.questions {\n  align-content: start;\n  display: grid;\n  grid-auto-rows: minmax(29px, auto);\n  min-height: 0;\n  overflow-y: auto;\n}\n\n.questions.grouped {\n  grid-auto-rows: minmax(29px, auto);\n}\n\n.question-group-heading {\n  background: #e8f1f8;\n  border-bottom: 1px solid #cad9e6;\n  color: #173a5e;\n  font-size: 0.72rem;\n  margin: 0;\n  padding: 0.25rem 0.55rem;\n}\n\n.question-row {\n  align-items: center;\n  border-bottom: 1px solid #e3e7ed;\n  min-height: 0;\n  padding: 0.08rem 0.45rem;\n}\n\n.question-row:nth-child(even) {\n  background: #f8fafc;\n}\n\n.question-text {\n  align-items: flex-start;\n  display: flex;\n  font-size: clamp(0.58rem, 0.76vw, 0.7rem);\n  line-height: 1.05;\n}\n\n.question-text span {\n  background: #e8eef5;\n  border-radius: 50%;\n  color: #1f4e78;\n  flex: 0 0 17px;\n  font-size: 0.58rem;\n  font-weight: 700;\n  line-height: 17px;\n  margin-right: 0.3rem;\n  text-align: center;\n}\n\n.choice-group {\n  display: flex;\n  gap: 0.1rem;\n  justify-content: center;\n}\n\n.choice-group button {\n  background: #fff;\n  border: 1px solid #aab5c3;\n  border-radius: 4px;\n  color: #34495e;\n  cursor: pointer;\n  font-size: 0.61rem;\n  font-weight: 700;\n  min-height: 20px;\n  min-width: 31px;\n  padding: 0.05rem 0.4rem;\n}\n\n.choice-group button:hover,\n.choice-group button:focus-visible {\n  border-color: #007bff;\n  outline: none;\n}\n\n.choice-group button.selected {\n  background: #007bff;\n  border-color: #007bff;\n  color: #fff;\n}\n\n.rating-group button {\n  min-width: 25px;\n  padding-inline: 0.4rem;\n}\n\n.comment-input,\ntextarea {\n  border: 1px solid #b8c2ce;\n  border-radius: 4px;\n  font: inherit;\n  min-width: 0;\n  line-height: 1.05;\n  padding: 0.18rem 0.35rem;\n  width: 100%;\n}\n\n.comment-input {\n  font-size: 0.65rem;\n  height: 24px;\n  min-height: 24px;\n  overflow: auto;\n  resize: none;\n  white-space: pre-wrap;\n}\n\n.comment-input:focus,\ntextarea:focus {\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.15);\n  outline: none;\n}\n\n.points {\n  color: #1f4e78;\n  font-size: 0.65rem;\n  text-align: center;\n}\n\n.questionnaire-footer {\n  align-items: center;\n  background: #f2f5f8;\n  border-top: 1px solid #d9e2ec;\n  box-sizing: border-box;\n  display: grid;\n  margin: 0 !important;\n  max-width: none !important;\n  padding: 0.5rem 0.65rem 0.6rem;\n  width: 100% !important;\n}\n\n.additional-comments {\n  display: grid;\n  font-size: 0.72rem;\n  font-weight: 700;\n  gap: 0.3rem;\n  grid-template-columns: minmax(0, 1fr);\n  justify-self: center;\n  margin: 0;\n  width: 66.666%;\n}\n\n.additional-comments > span {\n  color: #354a5f;\n  font-size: 0.7rem;\n}\n\ntextarea {\n  box-sizing: border-box;\n  height: 82px;\n  min-height: 82px;\n  resize: vertical;\n}\n\n@media (max-width: 900px) {\n  .additional-comments {\n    width: 100%;\n  }\n\n  .rating-key {\n    display: none;\n  }\n\n  .questionnaire-header {\n    grid-template-columns: 1fr auto auto;\n  }\n\n  .column-headings,\n  .question-row {\n    grid-template-columns: minmax(220px, 2.2fr) 68px 104px minmax(110px, 1fr) 28px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
